const compareEpisodeValues = (left, right) => {
  const leftNumber = Number(left);
  const rightNumber = Number(right);

  if (Number.isFinite(leftNumber) && Number.isFinite(rightNumber)) {
    return leftNumber - rightNumber;
  }

  return String(left).localeCompare(String(right), "fa", { numeric: true });
};

export const normalizeEpisodeTags = (tags) => {
  const values = Array.isArray(tags)
    ? tags
    : typeof tags === "string"
    ? [tags]
    : [];

  return [
    ...new Set(
      values
        .filter((tag) => typeof tag === "string")
        .map((tag) => tag.trim())
        .filter(Boolean)
    ),
  ].slice(0, 2);
};

export const groupEpisodesBySeason = (detail) => {
  const groups = new Map();

  for (const episode of Array.isArray(detail) ? detail : []) {
    if (
      !episode ||
      episode.seasonNumber === null ||
      episode.seasonNumber === undefined
    ) {
      continue;
    }

    const key = String(episode.seasonNumber);
    const episodes = groups.get(key) || [];
    episodes.push(episode);
    groups.set(key, episodes);
  }

  return Array.from(groups.values())
    .map((episodes) => ({
      seasonNumber: episodes[0].seasonNumber,
      seasonName:
        episodes
          .find((episode) => episode.seasonName?.trim())
          ?.seasonName.trim() || "",
      episodes: [...episodes].sort((left, right) =>
        compareEpisodeValues(left.episodeNumber, right.episodeNumber)
      ),
    }))
    .sort((left, right) =>
      compareEpisodeValues(left.seasonNumber, right.seasonNumber)
    );
};
